var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { staticClass: "nav-v2-shell" },
    [
      !_vm.semSidebar
        ? _c("NavegacaoV2Sidebar", {
            attrs: {
              collapsed: _vm.collapsed,
              mobile: _vm.isMobile,
              open: _vm.mobileOpen
            },
            on: {
              toggle: function($event) {
                _vm.collapsed = !_vm.collapsed
              }
            }
          })
        : _vm._e(),
      _vm.isMobile && _vm.mobileOpen
        ? _c("div", {
            staticClass: "nav-v2-shell__backdrop",
            on: { click: _vm.closeMobile }
          })
        : _vm._e(),
      _c(
        "main",
        { staticClass: "nav-v2-shell__main", style: _vm.mainStyle },
        [
          _c("NavTopbar", {
            attrs: {
              variant: _vm.contextoEfetivo,
              client: _vm.client,
              "show-hamburger": _vm.isMobile
            },
            on: { "toggle-menu": _vm.toggleMobile }
          }),
          _vm.isCliente
            ? _c("div", {
                staticClass: "nav-v2-shell__accent",
                style: { background: _vm.accentColor }
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "nav-v2-shell__content",
              style: { paddingRight: _vm.contentPaddingRight || null }
            },
            [_vm._t("default")],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }